import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import FormSelect from "./FormSelect";

/**
 * Component to render the Place Select dropdown
 *
 * @example
 * <PlaceSelect
 *   label=Rendered Text
 *   formId="ID of form element"
 *   formName={this.props.formName}
 *   data={this.props.statesData}
 *   labelField={VARIABLES.State}
 *   valueField={VARIABLES.StateID}
 *   value={this.state.selectedStateFips}
 *   disabledValue={this.state.comparisonStateFips}
 *   onChange={value =&gt; this.setState({selectedStateFips: value})}
 *  />;
 */
export default class PlaceSelect extends Component {

  static propTypes = {
    value: PropTypes.number,
    data: PropTypes.array,
    valueField: PropTypes.string,
    labelField: PropTypes.string,
    disabledValue: PropTypes.number,
    label: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  renderOptions = () => {
    const getLabel = item => _.get(item, this.props.labelField)
    const getValue = item => _.get(item, this.props.valueField)

    return _.map(this.props.data, item => (
      <option
        key={getValue(item)}
        value={getValue(item)}
        children={getLabel(item)}
        disabled={getValue(item) === this.props.disabledValue}
      />
    ));
  };

  getValue = () => {
    return this.props.value ? _.toString(this.props.value) : "";
  }

  handleChange = (value) => {
    const valueAsNumber = value ? _.toNumber(value) : null;
    this.props.onChange(valueAsNumber)
  }

  render() {
    const disabled = _.isEmpty(this.props.data)

    return (
      <FormSelect
        disabled={disabled}
        noneOption={true}
        value={this.getValue()}
        label={this.props.label}
        formId={this.props.formId}
        formName={this.props.formName}
        onChange={this.handleChange}
        children={this.renderOptions()}
      />
    );
  }
}
